import React from 'react';
import { useModal } from '../../../components/Modal/PresentedModal';
import { t } from '../../../locales/translate';
import { FormForm } from '../../../components/Form/FormForm';
import { Text } from '../../../components/text/text';

interface Props {
  onSubmit?: () => void;
  deliveryCode: string;
}

export function ConfirmDeliveryModal({ onSubmit, deliveryCode }: Props): JSX.Element {
  const { open, Modal, close, size } = useModal();

  return (
    <Modal open={open} size={size} title={t.page.fulfillmentDetails.confirmBooking}>
      <FormForm
        onSubmit={() => {
          onSubmit?.();
          close();
        }}
        onClose={close}
        canSubmit
        saveButtonTitle={t.component.confirmation.confirm}
      >
        <Text type="card-text">{t.page.fulfillmentDetails.confirmBookingDescription(deliveryCode)}</Text>
      </FormForm>
    </Modal>
  );
}
